import { render, staticRenderFns } from "./RedBook.vue?vue&type=template&id=5a1a42de&scoped=true&"
import script from "./RedBook.vue?vue&type=script&lang=js&"
export * from "./RedBook.vue?vue&type=script&lang=js&"
import style0 from "./RedBook.vue?vue&type=style&index=0&id=5a1a42de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1a42de",
  null
  
)

export default component.exports